// each and every const here has to be totally unique from one another

export const typoPrefix_number = "number";
export const typoPrefix_title = "title";
export const typoPrefix_subTitle = "subTitle";
export const typoPrefix_content = "content";
export const typoPrefix_buttonText = "buttonText";
